<template>
    <div>
        <section class="section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-1 bg-gradient-primary">
            </div>
        </section>
        <section class="section pt-5 pb-5">
            <div class="container container-lg">
                <div class="row">
                    <div class="col-lg-4">
                        <profile-navigation :name="firstName"></profile-navigation>
                    </div>
                    <div class="col-lg-8">
                        <h4>Meus Dados</h4>
                        <card class="mb-4" shadow no-body>
                            <div class="px-4 py-4">
                                <form role="form" @submit.prevent method="get">
                                <div class="row">
                                    <div class="col-md-6">
                                        <base-input placeholder="Nome" :valid="formerrors.first_name" v-model="inputs.first_name" :disabled="$wait.is('profile.load')"></base-input>
                                    </div>
                                    <div class="col-md-6">
                                        <base-input placeholder="Sobrenome" :valid="formerrors.last_name" v-model="inputs.last_name" :disabled="$wait.is('profile.load')"></base-input>
                                    </div>
                                    <div class="col-md-6">
                                        <base-input placeholder="Localidade" :valid="formerrors.localidade" v-model="inputs.perfil.localidade" :disabled="$wait.is('profile.load')" addon-left-icon="fa fa-map-marker"></base-input>
                                    </div>
                                    <div class="col-md-6">
                                        <base-input addon-left-icon="ni ni-calendar-grid-58" v-mask="'##/##/####'">
                                            <flat-picker slot-scope="{focus, blur}"
                                                @on-open="focus"
                                                @on-close="blur"
                                                :config="flatPickerConfig"
                                                class="form-control datepicker"
                                                placeholder="Data de Aniversário"
                                                :disabled="$wait.is('profile.load')"
                                                :valid="formerrors.aniversario"
                                                v-model="inputs.perfil.aniversario">
                                            </flat-picker>
                                        </base-input>
                                    </div>
                                    <div class="col">
                                        <div class="text-center">
                                            <base-button nativeType="submit"
                                                @click="update($event)"
                                                type="primary"
                                                :disabled="$wait.is('profile.load')"
                                                class="mt-3">
                                                <i class="fa fa-pencil-square-o mr-1"></i>
                                                Alterar meus dados
                                            </base-button>
                                        </div>
                                    </div>
                                </div>
                                </form>
                            </div>
                        </card>
                        <h4>Alterar Senha</h4>
                        <card class="mb-4" shadow no-body>
                            <div class="px-4 py-4">
                                <form role="form" @submit.prevent method="get">
                                <div class="row">
                                    <div class="col-md-6">
                                        <base-input 
                                            type="password"
                                            id="password1"
                                            addon-left-icon="fa fa-lock"
                                            v-model="inputs.new_password1"
                                            placeholder="Senha">
                                        </base-input>
                                    </div>
                                    <div class="col-md-6">
                                        <base-input 
                                            type="password"
                                            id="password2"
                                            v-model="inputs.new_password2"
                                            addon-left-icon="fa fa-lock"
                                            placeholder="Repita a Senha">
                                        </base-input>
                                    </div>
                                    <div class="col">
                                        <password v-model="inputs.new_password1" :strength-meter-only="true" @score="updateStrengthText" />
                                        <div class="text-muted text-center">
                                            <small>força da senha:
                                                <span class="font-weight-700" :style="{color}">{{strength_password}}</span>
                                            </small>
                                        </div>
                                        <div class="text-center">
                                            <base-button nativeType="submit"
                                                @click="change_password($event)"
                                                type="primary"
                                                class="mt-3">
                                                <i class="fa fa-lock mr-1"></i>
                                                Alterar minha senha
                                            </base-button>
                                        </div>
                                    </div>
                                </div>
                                </form>
                            </div>
                        </card>
                        <h4>Contas Sociais</h4>
                        <p>Essas são suas contas sociais utilizadas para acessar o site.</p>
                        <card class="mb-4" shadow no-body v-show="!$wait.is('profile.load')">
                            <div class="px-4 py-4">
                                <div class="d-md-flex justify-content-between align-items-center">

                                    <base-button type="secondary" @click="connect('facebook')" class="my-2 w-auto" v-if="!socialAccount.facebook">
                                        <img slot="icon" src="img/icons/common/facebook.svg">
                                        Conectar Facebook
                                    </base-button>
                                    <base-button type="secondary" @click="disconnect('facebook')" class="my-2 w-auto" v-else>
                                        <img slot="icon" src="img/icons/common/facebook.svg">
                                        Desconectar Facebook
                                    </base-button>

                                    <base-button type="secondary" @click="connect('google')" class="my-2 w-auto" v-if="!socialAccount.google">
                                        <img slot="icon" src="img/icons/common/google.svg">
                                        Conectar Google
                                    </base-button>
                                    <base-button type="secondary" @click="disconnect('google')" class="my-2 w-auto" v-else>
                                        <img slot="icon" src="img/icons/common/google.svg">
                                        Desconectar Google
                                    </base-button>
                                </div>
                            </div>
                        </card>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import ProfileNavigation from './components/ProfileNavigation.vue'
import Password from 'vue-password-strength-meter'
import { userMixin } from "@/mixins/userMixin";

import flatPicker from "vue-flatpickr-component";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";
import "flatpickr/dist/flatpickr.css";

import {mask} from 'vue-the-mask'

export default {
	name: 'profile-home',
    mixins: [userMixin],
    components: {
        ProfileNavigation, Password, flatPicker
    },
    directives: {mask},
    data () {
      return {
        flatPickerConfig: {
          //altFormat: "d/m/Y",
          //altInput: true,
          //dateFormat: "Y-m-d",
          dateFormat: "d/m/Y",
          locale: Portuguese,
          allowInput: true    
        },
        modal: {
          title: 'Falha na Operação!',
          body: 'Não foi possível completar a operação',
          classe: 'modal-danger',
          icon: 'fa fa-times-circle',
          okButton: 'OK',
        },
        socialAccount: {
            google: null,
            facebook: null
        },
        formerrors: {},
      }
    },
    computed: {
        firstName: function() {
            return this.$store.state.auth.first_name
        },
    },
    methods: {
        update(event) {
            event.preventDefault();
            this.formerrors = {};
            let fail = false;
            
            if ( !this.inputs.first_name ){
                this.formerrors['first_name'] = false;
                fail = true;
            }

            if ( !this.inputs.last_name ){
                this.formerrors['last_name'] = false;
                fail = true;
            }

            if ( fail == false ) {
                this.$wait.start('profile.load');
                this.update_profile().then(response => {
                    if ( this.$store.state.auth.profileRequestError !== null ){
                        let errors = this.$store.state.auth.profileRequestError;
                        Object.keys(errors).forEach(key => {
                            this.formerrors[key] = false;
                        });
                    }else {
                        if ( this.$store.state.auth.first_name !== response.first_name ) {
                            let objectUser = {
                              'username': this.$store.state.auth.username,
                              'first_name': response.first_name,
                              'avatar': this.$store.state.auth.avatar
                            };
                            this.$store.dispatch('auth/setLoginData', objectUser);
                        }
                    }
                    this.$wait.end('profile.load');
                });
            }         
        }
    },
    created() {
        this.$wait.start('profile.load');
        this.load_profile().then(response => {
            this.inputs.first_name = response.first_name;
            this.inputs.last_name = response.last_name;
            this.inputs.perfil.localidade = response.perfil.localidade || null;
            this.inputs.perfil.aniversario = response.perfil.aniversario  || null;

            this.load_social_accounts();

            this.$wait.end('profile.load');
        });

        // beforerouteleave limpar inputs..
    }
};
</script>
